import BaseAPIClient from '~/clientUtils/baseApiClient';
import { UpdateZipcodeRequest } from '~/definitions/zipcode';

class ZipcodeApi extends BaseAPIClient {
    constructor() {
        super('', {});
    }

    async getZipcode(id: string): Promise<{ value: string }> {
        return this.request({
            method: 'GET',
            url: `/api/zipcode/${id}`,
        });
    }

    async getExistingZipcode(id: string): Promise<string[]> {
        return this.request({
            method: 'GET',
            url: `/api/zipcode/existingZipcodeList/${id}`,
        });
    }

    async updateZipcode(params: UpdateZipcodeRequest): Promise<void> {
        return this.request({
            method: 'PUT',
            url: `/api/zipcode/${params.regionId}`,
            data: { ...params.data },
        });
    }

    async checkAssignedZipcode(id: string): Promise<boolean> {
        return this.request({
            method: 'GET',
            url: `/api/zipcode/checkAssignedZipcode/${id}`,
        });
    }

    async assignZipcode(id: string): Promise<void> {
        return this.request({
            method: 'POST',
            url: `/api/zipcode/${id}`,
        });
    }
}

const zipcodeApi = new ZipcodeApi();

export default zipcodeApi;
